import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const startLoading = () => {
    let LoadingLogo = document.getElementById('LoadingLogo-id');
    LoadingLogo.style.display = 'flex'
    setLoading(true);
  };

  const stopLoading = () => {
    let LoadingLogo = document.getElementById('LoadingLogo-id');
    LoadingLogo.style.display = 'none'
    setLoading(false);
  };

  return (
    <LoadingContext.Provider value={{ loading, startLoading, stopLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
